import axios from "axios";
import {
	NOTIFICATION_INIT,
	NOTIFICATION_LOADED,
	NOTIFICATION_LOADING,
	NOTIFICATION_LOADING_FAILED
} from "./types";
export const initNotifications= () => (dispatch) => {
	dispatch({ type: NOTIFICATION_INIT });
}
export const loadNotifications = (listdata) => (dispatch) => {
	dispatch({ type: NOTIFICATION_LOADING });

	let formData = new FormData(); //formdata object
	console.log("loadNotifications data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: NOTIFICATION_LOADED, payload: response });

			console.log("loadNotifications=", response);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: NOTIFICATION_LOADING_FAILED,
				payload: error,
			});
		});
};

export const loadLiveNotifications = (listdata) => (dispatch) => {
	dispatch({ type: NOTIFICATION_LOADING });

	console.log("loadNotifications data=", listdata);
	dispatch({ type: NOTIFICATION_LOADED, payload: listdata });
};
